import React from "react";
import {Button, Modal} from "react-bootstrap";

const UpdateBillingAddressModal = ({onHide, onSaveSiteOnly, onSaveSiteAndCustomer}) => {
    return (
        <Modal
            bsSize='small'
            show={true}
            onHide={onHide}
            backdrop='static'
            className='heightAuto fontIOS'
        >
            <Modal.Header>
                <Modal.Title>Confirm saving</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <h4 className='text-center'>
                    This site address matches customer billing address. Do you want to update customer billing address too?
                </h4>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    bsSize='small'
                    bsStyle='success'
                    onClick={onSaveSiteOnly}
                >
                    Save Site Only
                </Button>
                <Button
                    bsSize='small'
                    bsStyle='success'
                    onClick={onSaveSiteAndCustomer}
                >
                    Save Site + Customer
                </Button>
                <Button
                    bsSize='small'
                    bsStyle='warning'
                    onClick={onHide}
                >
                    Cancel
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default UpdateBillingAddressModal;
